






import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import QuestionPreviewComponent from "./QuestionPreviewComponent.vue";
import Question from "../models/Question";
import questionParser from "../../../helpers/question-parser";
import { State, Getter, Action, Mutation } from "../store-helper";

@Component({
  components: {
    QuestionPreviewComponent,
  },
})
export default class PreviewComponent extends Vue {}
